import React, { PropTypes } from 'react'
import { Table, Column } from 'fixed-data-table';
import _ from 'lodash';
import custJqAjax from '../../../commonJS/custJqAjax';

import {
	DataListWrapper,
	SortTypes,
	SortHeaderCell,
	TextCell,
	NewsTypeCell,
	TimeWithoutHHmmssCell,
} from "../../../commonComponents/DataTable/DataTablePs";


export default class NewsDataTableCt extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			colSortDirs: {},
			rowItem: {}
		}

		this.ajaxsWip = [];

		this.onSortChange = this.onSortChange.bind(this);
		this.onRowClick = this.onRowClick.bind(this);
		this.loadData = this.loadData.bind(this);
	}

	componentWillMount() {
		this.loadData();
	}

	loadData() {
		custJqAjax({
			type: 'get',
			ajaxsWip: this.ajaxsWip,
			custId: this.props.propsPackageFromSkyFamily.jqAjaxIdGenerator.getId(),
			url: '/api/W_SaleSky_News_Lang_Get.php',
			success: response => {
				let defaultSortIndexes = [];
				let news = response.result;
				let size = response.result.length;

				// 多國語系格式調整
				news = news.map((item, ind) => {
					// 設定帶繁體中文
					item.title = item.title_list.title_tw;
					item.message = item.message_list.message_tw;
					return item;
				});

				let news_pin = _.filter(news, ['flag', 'pin']);//置頂的陣列
				let news_star = _.filter(news, ['flag', 'star']);//重要的陣列
				let news_normal = _.filter(news, ['flag', 'normal']);//一般的陣列

				let newsOrderByFlag = _.concat(news_pin, news_star, news_normal);//排列順序: 置頂-重要-一般

				for (let i = 0; i < size; i++) {
					defaultSortIndexes.push(i);
				}

				this.props.returnDataListToDashboardFunc(new DataListWrapper(defaultSortIndexes, newsOrderByFlag), 'newsTable');

				this.setState({
					originDataList: new DataListWrapper(defaultSortIndexes, newsOrderByFlag),//最初的排序
				});

			},
			error: (xhr, ajaxOptions, thrownError) => { }
		});
	}

	componentWillUnmount() {
		this.props.propsPackageFromSkyFamily.ajaxAborter(this.ajaxsWip);
	}

	onSortChange(columnKey, sortDir) {
		/*
			按表頭排序
			defaultSortIndexes: [] 預設的排序,依照index
		*/
		let filteredDataList = this.props.filteredDataList._data;

		let defaultSortIndexes = [];
		let size = filteredDataList.length;
		for (let i = 0; i < size; i++) {
			defaultSortIndexes.push(i);
		}

		if (columnKey === 'flag') {
			//點選"標記"時, 一律依照置頂-重要-一般 的順序
			this.props.returnDataListToDashboardFunc(new DataListWrapper(defaultSortIndexes, this.state.originDataList._data), 'newsTable');
		} else {
			let sortIndexes = defaultSortIndexes.slice();
			sortIndexes.sort((indexA, indexB) => {
				/*eslint no-useless-escape: "off"*/
				const valueA = this.state.originDataList.getObjectAt(indexA)[columnKey].replace(/[\ |\-|\:|\?]/g, "");
				const valueB = this.state.originDataList.getObjectAt(indexB)[columnKey].replace(/[\ |\-|\:|\?]/g, "");

				let sortVal = 0;
				if (valueA > valueB) {
					sortVal = 1;
				}
				if (valueA < valueB) {
					sortVal = -1;
				}
				if (sortVal !== 0 && sortDir === SortTypes.ASC) {
					sortVal *= -1;
				}

				return sortVal;
			});

			this.props.returnDataListToDashboardFunc(new DataListWrapper(sortIndexes, this.state.originDataList._data), 'newsTable');
		}

		this.setState({
			colSortDirs: { [columnKey]: sortDir },
		});
	}

	onRowClick(row) {
		this.setState({ rowItem: row, rowId: row.id, });
		this.props.routeHandler(`/salesky/news/${row.id}`);
	}

	render() {
		let { filteredDataList } = this.props;

		// search process
		let sortFunc = this.onSortChange;
		if (this.props.searchResults._data) {
			filteredDataList = this.props.searchResults;
			// 搜尋結果暫不提供排序功能
			sortFunc = "";
		}

		let {
			colSortDirs,
		} = this.state;
		let childrenWithProps = React.Children.map(this.props.children, (child) => React.cloneElement(child, {
			closeModal: this.props.closeModal,
			rowItem: this.state.rowItem,
			reloadDataList: this.loadData,
		}));

		if (this.props.tableFrom !== 'newsTable') {
			/*
				 為了讓NavBarGroup與SideBarGroupCt能夠溝通( 當搜尋bar onChange的時候, SideBarGroupCt裡面的TableCt也要跟著filter )
				 Table Filter的function就得寫在他們共同的父親SaleSkyDashboardCt,
				 DataListWrapper物件則由SaleSkyDashboardCt透過props傳給NewsDataTableCt.
				 但如果SaleSkyDashboardCt還存有上一個Tab的DataListWrapper(如Customer),
				 而使用者切換到News, 會發生"將Customer的DataList傳給News"的悲劇.
				 所以我設了一個tableFrom的prop(只是個字串),當props傳下來的時候,檢查傳下來的資料,是不是現在的Ct所需要的.
				 若不是的話, 就顯示"讀取中 請稍後",
				 直到正確的DataList傳下來,才會顯示Table.
				 
				 一定有更好的做法,不過時間太趕想不出來. 請高手改進.
			*/
			return <div>讀取中 請稍後</div>
		}
		return (
			<div>
				<Table
					rowHeight={50}
					headerHeight={50}
					rowsCount={filteredDataList.getSize()}
					width={(this.props.isBigSideBar ? 0 : 186) + this.props.workLogProps.tableWidth}
					height={this.props.tableHeight || 477}
					onRowClick={(event, rowIndex) => this.onRowClick(filteredDataList.getObjectAt(rowIndex))}//onRowClick自帶三個props: event, rowIndex, Object
					{...this.props}>
					<Column
						columnKey="title"
						width={300}
						cell={<TextCell sortedData={filteredDataList} />}
						header={
							<SortHeaderCell
								onSortChange={sortFunc}
								sortDir={colSortDirs.title}>
								標題
                            </SortHeaderCell>
						}
					/>
					<Column
						columnKey="flag"
						width={100}
						cell={<NewsTypeCell sortedData={filteredDataList} />}
						header={
							<SortHeaderCell
								onSortChange={sortFunc}
								sortDir={colSortDirs.flag}>
								標記
                            </SortHeaderCell>
						}
					/>
					<Column
						columnKey="type_name"
						width={200}
						cell={<TextCell sortedData={filteredDataList} />}
						header={
							<SortHeaderCell
								onSortChange={sortFunc}
								sortDir={colSortDirs.type_name}>
								分類
                            </SortHeaderCell>
						}
					/>
					<Column
						columnKey="start_time"
						width={120}
						cell={<TimeWithoutHHmmssCell sortedData={filteredDataList} />}
						header={
							<SortHeaderCell
								onSortChange={sortFunc}
								sortDir={colSortDirs.start_time}>
								起始時間
                            </SortHeaderCell>
						}
					/>
					<Column
						columnKey="end_time"
						width={120}
						cell={<TimeWithoutHHmmssCell sortedData={filteredDataList} />}
						header={
							<SortHeaderCell
								onSortChange={sortFunc}
								sortDir={colSortDirs.end_time}>
								結束時間
                            </SortHeaderCell>
						}
					/>
					<Column
						columnKey="message"
						width={360}
						cellClassName="messageCol"
						cell={<TextCell sortedData={filteredDataList} />}
						header={
							<SortHeaderCell
								onSortChange={sortFunc}
								sortDir={colSortDirs.message}>
								內容
                            </SortHeaderCell>
						}
						flexGrow={1}
					/>
				</Table>
				{ childrenWithProps}
			</div>
		);
	}
}

NewsDataTableCt.PropTypes = {
	filteredDataList: PropTypes.object.isRequired,
}



// WEBPACK FOOTER //
// ./src/salesky/routes/news/NewsDataTableCt.jsx